module.exports = __webpack_public_path__ + "static/img/bg11.be75d8d.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/bg11.png
// module id = Vh/m
// module chunks = 1